import { Dialog } from "@material-ui/core";
import { Button } from "@resource/atlas";
import { atlasArrowLeft } from "@resource/atlas/icons";
import InterviewerProfile from "components/InterviewerProfile/InterviewerProfile";
import ProminentInstructionsCard from "components/legacy/modules/shared/ProminentInstructionsCard";
import RichText from "components/RichText";
import _ from "lodash";
import moment from "moment";
import { useState } from "react";
import { Event } from "types/legacy";

import VideoIntro from "../../InterviewTeam/InterviewerModal/VideoIntro";
import styles from "./Event.module.scss";

type EventModalProps = {
  event: Event;
  open: boolean;
  onClose(): void;
  showInterviewers?: boolean;
};

function EventModal({
  event,
  open,
  onClose,
  showInterviewers = true,
}: EventModalProps) {
  const [showingVideoIntroductionUrl, setShowingVideoIntoductionUrl] =
    useState("");
  const {
    title,
    startTime,
    endTime,
    interviewers,
    description,
    prominentInstructions,
  } = event;
  const eventInPast = moment(endTime).isBefore(moment());
  const startTimeText = moment(startTime).format("h:mm a");
  const endTimeText = moment(endTime).format("h:mm a");

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby={styles.title}
      aria-describedby={styles.description}
      fullWidth
    >
      {showingVideoIntroductionUrl ? (
        <div>
          <div className="px-4 py-2">
            <Button
              icon={atlasArrowLeft}
              isGhost
              aria-label="Back to interview details"
              className="pl-2.5"
              onClick={() => setShowingVideoIntoductionUrl("")}
            />
          </div>
          <div className="px-8 pb-8">
            <VideoIntro mediaLink={showingVideoIntroductionUrl} />
          </div>
        </div>
      ) : (
        <div className="p-8 space-y-10">
          <div className="space-y-2">
            <RichText
              className="text-h1"
              rawHtml={title}
              sanitizeOptions={{
                ALLOWED_TAGS: [],
              }}
            />
            <p className="text-body-md">{`${startTimeText} - ${endTimeText}`}</p>
            <div className="text-body-md">
              <RichText rawHtml={description} />
              {!eventInPast && (
                <div className="flex flex-col gap-y-3 mt-4">
                  {_.map(prominentInstructions, (i) => (
                    <ProminentInstructionsCard
                      key={i.id}
                      label={i.label}
                      url={i.url}
                    />
                  ))}
                </div>
              )}
            </div>
          </div>
          {showInterviewers && !!(interviewers || []).length && (
            <div>
              <p className="text-h3">Interviewers</p>
              <div className="space-y-2 mt-2">
                {_.map(interviewers, (interviewer) => (
                  <div
                    key={interviewer.id}
                    className="p-4 border-light-gray-600 border rounded-md"
                  >
                    <InterviewerProfile
                      variant="small"
                      personalProfile={interviewer}
                      onVideoIntroductionClick={() => {
                        if (interviewer.videoIntroductionUrl) {
                          setShowingVideoIntoductionUrl(
                            interviewer.videoIntroductionUrl
                          );
                        }
                      }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
    </Dialog>
  );
}
export default EventModal;
